








































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateOpportunitySourceRequest from '@/models/Opportunities/CreateOpportunitySourceRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'OpportunitySourceCreate'
})
export default class extends GiganautVueDialog {

  public entity = new CreateOpportunitySourceRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateOpportunitySourceRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.createOpportunitySource(this.entity)
    this.dialog = false;
  }
}
